import SchedulingAssistantState from './schema/SchedulingAssistantState';
import { createStore } from 'satcheljs';

const defaultSchedulingAssistantStore: SchedulingAssistantState = {
    calendarEventData: {
        Start: null,
        End: null,
        IsAllDayEvent: false,
        RequiredAttendees: null,
        OptionalAttendees: null,
        Resources: null,
        Organizer: null,
        IsOrganizer: false,
        IsProposeNewTime: false,
        Recurrence: null,
        ParentFolderId: null,
    },
    viewState: {
        gridRangeStart: null,
        gridLeft: 0,
        gridRight: 0,
        countOfDays: null,
        isExpanded: null,
        canModifyAttendees: false,
        currentGroupInAddAttendeeMode: null,
        showWorkingHoursOnly: false,
        isDirty: null,
        colorScheme: null,
        peoplePickerViewState: null,
        showRoomPicker: false,
        scrollLeft: 0,
        scrollTop: 0,
        scrollLeftMax: 0,
        leftNavWidth: 0,
        initialEnd: null,
        initialStart: null,
        initialIsAllDayEvent: false,
        originalEventEnd: null,
        originalEventStart: null,
        originalEventIsAllDayEvent: false,
        showTimeZones: false,
        IsAcceptProposeNewTime: false,
        shouldAdjustStartTimeEndTime: false,
        isAllDayEventExplicitlySet: false,
    },
};

export const getStore = createStore<SchedulingAssistantState>(
    'schedulingAssistantStore',
    defaultSchedulingAssistantStore
);
export default getStore;
